// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2CM62","item":"PaymentsMobile_item__1uuGZ","label":"PaymentsMobile_label__1admf","amount":"PaymentsMobile_amount__L1ZS2"};